import React from 'react';
import { useHistory } from 'react-router-dom';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import { Card } from 'baseui/card';
import { CardItem } from 'commons-ui';
import { URL, LABEL, DOWNTIME_REFUND_RESOURCES, IMAGE_SOURCE } from './helper';
import useDowntimeRefundHome from './useDowntimeRefundHome';
import useDowntimeRefundHomeCss from './useDowntimeRefundHomeCss';

const DowntimeRefundHome: React.FC<{}> = () => {
	const history = useHistory();
	const { isEnabled } = useDowntimeRefundHome();
	const { keyHeading, subKeyHeading, cardCSS } = useDowntimeRefundHomeCss();

	return (
		<div className={keyHeading}>
			{_map(_keys(DOWNTIME_REFUND_RESOURCES), (subEntity: string) => {
				return isEnabled(subEntity) ? (
					<div
						key={subEntity}
						className={subKeyHeading}
						role='button'
						tabIndex={0}
						onClick={(e) => {
							e.preventDefault();
							history.push(URL[subEntity]);
						}}>
						<Card
							overrides={{
								Root: {
									style: () => cardCSS
								},
								Body: {
									component: () => <CardItem label={LABEL[subEntity]} img={IMAGE_SOURCE[subEntity]} />
								}
							}}
						/>
					</div>
				) : null;
			})}
		</div>
	);
};

export default DowntimeRefundHome;
